<template>
    <StoryblokPageContainer v-if="story" :story="story">
        <ProductStoryblok v-if="story" :story="story" />
    </StoryblokPageContainer>
</template>

<script setup lang="ts">
import StoryblokPageContainer from '~/components/page-building/StoryblokPageContainer.vue';
import useStoryblokSeoData from '~/composables/useStoryblokSeoData';
import {
    sendDataLayerEcommerceEvent,
    sendDataLayerPageView,
} from '~/composables/useDataLayer';

const { initBridge, story } = await useStoryblokStory({
    contentType: 'product',
    folder: 'products',
});

useStoryblokSeoData(story.value);
sendDataLayerPageView();

const translatedEcommerceItems = story.value?.content?.variations?.map(
    (item: any, index: number) => {
        return {
            item_id: item.content?.database_product?.id,
            item_name: item.name,
            index: index,
            item_category:
                item.content?.category?.length > 0
                    ? item.content?.category[0]
                    : '',
            item_category2: item.content?.product_type,
            item_category3:
                item.content?.material?.length > 0
                    ? item.content?.material[0]
                    : '',
            item_list_name:
                item.content?.category?.length > 0
                    ? item.content?.category[0]
                    : '',
            is_sample:
                item.content?.database_product?.sku?.includes('SAMPLE') ??
                false,
            color: null,
            material:
                item.content?.material?.length > 0
                    ? item.content?.material[0]
                    : '',
            finish: null,
            size: null,
        };
    },
);

sendDataLayerEcommerceEvent('view_item', '', {
    currency: 'USD',
    value: 0,
    items: translatedEcommerceItems,
});

onMounted(initBridge);
</script>
